import { analyticsService } from '@/services/AnalyticsService';

export function initializeGA4(): void {
    const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;

    if (!measurementId || document.getElementById('ga-gtag-script')) {
        return;
    }

    const script = document.createElement('script');
    script.id = 'ga-gtag-script';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    script.onload = () => {
        gtag('js', new Date());
        gtag('config', measurementId);
    };

    analyticsService.updateConsent(true);
}

declare function gtag(...args: any[]): void;